export default "__VITE_ASSET__CK_EZ1Kh__"